import './App.module.scss';

import React, { useEffect } from 'react';
import { Alerter } from './components';
import LoadingModal from './components/LoadingModal';
import { useReduxSync } from './hooks';
import useLanguageFromProfileStore from './hooks/useLanguageFromProfileStore';
import { useAppSelector } from './reducer/hooks';
import { selectProfile } from './reducer/profileSlice';
import { versionNumber } from './utils/constant';
import useToken from './hooks/useToken';
import PublicRoutes from './routes/PublicRoutes';
import AuthenticatedRoutes from './routes/AuthenticatedRoutes';

const App = () => {
  useEffect(() => console.log('versionNumber', versionNumber), []);

  useReduxSync();
  useLanguageFromProfileStore();

  const profile = useAppSelector(selectProfile);
  const isTokenReady = useToken();

  const isLogin = profile.isLogged;

  if (isLogin && !isTokenReady) return <></>;

  return (
    <>
      <Alerter />
      <LoadingModal />
      {isLogin && isTokenReady ? <AuthenticatedRoutes /> : <PublicRoutes />}
    </>
  );
};

export default App;
